import axios from "axios";
import { IContactInfo } from "../../../Models/ContactInfo/IContactInfo";
import { IResult } from "../../../Models/Result/IResult";
import { formatUrl, handleError } from "../ApiHelpers";
import { IContactInfoApi } from "./IContactInfoApi";

export class ContactInfoApi implements IContactInfoApi {

    private backendUrl: string;

    constructor(url: string) {
        this.backendUrl = url;
    }

    async getContactInfo(): Promise<IResult<IContactInfo>> {
        try {
            const url = formatUrl(this.backendUrl, `/api/ContactInfo/GetContactInfo`);
            const response = await axios.get(url);
            return response.data as IResult<IContactInfo>;
        }
        catch (error) {
            return handleError(error, "getContactInfo");
        }
     
    }

    async saveContactInfo(info: IContactInfo): Promise<IResult<IContactInfo>> {
        try {
            const url = formatUrl(this.backendUrl, `/api/ContactInfo/SaveContactInfo`);
            const response = await axios.post(url,info);
            return response.data as IResult<IContactInfo>;
        }
        catch (error) {
            return handleError(error, "saveContactInfo");
        }
    }

}